/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import { Navigate } from 'react-router-dom';
import Globals from '../shared/Globals';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import sanitizeHtml from 'sanitize-html';
import { qreq } from '../shared/qrequest';

const allowedHTML = {
    parseStyleAttributes: false,
    allowedTags: ['table', 'thead', 'tbody', 'tr', 'td', 'th', 'div', 'span', 'b', 'i', 'strong', 'h1', 'h2', 'h3', 'h4', 'h5', 'hr', 'img', 'br', 'p', 'ul', 'ol', 'li'],
    allowedAttributes: {
        table: ['style', 'class'],
        b: ['style', 'class'],
        i: ['style', 'class'],
        strong: ['style', 'class'],
        div: ['style', 'class', 'varnote'],
        span: ['style', 'class'],
        tr: ['style', 'class'],
        td: ['style', 'class', 'colspan'],
        th: ['style', 'class', 'colspan'],
        a: ['href', 'target'],
        img: ['src', 'alt', 'style', 'class']
    },
    allowedSchemes: ['data', 'http', 'https']
};

export default class BaseCom extends React.Component {

    constructor(props, state) {
        if (!props)
            props = {};
        super(props);
        if (!state)
            state = {};
        this.state = state;
        this.set = this.set.bind(this);
        this.get = this.get.bind(this);
        this.goBack = this.goBack.bind(this);
        this.alert = this.alert.bind(this);
        this.requireLogin = this.requireLogin.bind(this);
        this.wrapModal = this.wrapModal.bind(this);
    }

    set(a, b) {
        var state = this.state;
        state[a] = b;
        this.setState(state);
    }

    get(a) {
        return this.state[a];
    }

    goBack() {
        window.history.go(-1);
    }

    success(msg) {
        this.toast().success(msg);
    }

    alert(msg) {
        this.toast().error(msg);
    }

    warn(msg) {
        this.toast().warn(msg);
    }

    info(msg) {
        this.toast().info(msg);
    }

    showError(msg) {
        this.toast().error(msg);
    }

    navigate(loc) {
        return (<Navigate to={loc} />);
    }

    requireLogin(section, callback) {

        if (callback) {
            callback(Globals.get('user'));
        }

        return Globals.get('user') ? true : false;
    }

    wrapModal(children, title, size) {
        return <Modal show={this.props.show} onHide={() => { if (this.props.onHide) this.props.onHide(); }} size={size}>
            {title ?
                <Modal.Header closeButton={this.props.onHide ? true : false}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header> : ''}
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>;
    }

    toast() {
        return toast;
    }

    unkownErrorCallback() {
        toast.error('Unknown error ocurred. Please try again.');
    }

    processHTML(html, allowLinks) {
        if (allowLinks) {
            var allowed = { ...allowedHTML, allowedTags: [...allowedHTML.allowedTags, 'a'] };
            return sanitizeHtml(html, allowed);
        }
        else
            return sanitizeHtml(html, allowedHTML);
    }

    fillItem(api, vname, successCallback, errorCallback) {
        if (!vname) vname = 'item';
        qreq.get(api, j => {
            if (j.item) {
                this.setState({ [vname]: j.item });
                successCallback?.(j.item);
            }
            else {
                this.alert(j.errorMessage);
                errorCallback?.(j.errorMessage);
            }
        }, () => {
            this.unkownErrorCallback();
            errorCallback?.();
        });
    }

    fillItemAsync(api, vname) {
        return new Promise((resolve, reject) => {
            this.fillItem(api, vname, resolve, resolve);
        });
    }

    fillList(api, vname, usePost, successCallback, errorCallback) {
        if (usePost) {
            qreq.post(api, {}, j => {
                if (j.list) {
                    this.setState({ [vname]: j.list });
                    successCallback?.(j.list);
                }
                else {
                    this.alert(j.errorMessage);
                    errorCallback?.(j.errorMessage);
                }
            }, () => {
                this.unkownErrorCallback();
                errorCallback?.();
            });
        }
        else {
            qreq.get(api, j => {
                if (j.list) {
                    this.setState({ [vname]: j.list });
                    successCallback?.(j.list);
                }
                else {
                    this.alert(j.errorMessage);
                    errorCallback?.(j.errorMessage);
                }
            }, () => {
                this.unkownErrorCallback();
                errorCallback?.();
            });
        }
    }

    fillListAsync(api, vname, usePost) {
        return new Promise((resolve, reject) => {
            this.fillList(api, vname, usePost, resolve, resolve);
        });
    }

    getOrg = () => {
        return new Promise(async (resolve, reject) => {
            try {
                let j = await qreq.getAsync('/api/organization/get/current?siteDomainID=' + (this.props.params.templateID ?? '0'));
                if (j.item) {
                    this.setState({ org: j.item });
                    resolve(j.item);
                }
                else
                    reject(j);
            }
            catch (e) {
                reject(e);
            }
        });
    }

    notVanilla = (isNotVanilla, isVanilla) => {
        let vanilla = Globals.get('vanilla');
        if (vanilla === null || vanilla === undefined) {
            qreq.get('/api/settings/vanilla', v => {
                let x = v?.item;
                Globals.set('vanilla', x);
                this.setState({ vanilla: x });
                if (!x) isNotVanilla?.();
                else isVanilla?.();
            });
        }
        else {
            if (!vanilla) isNotVanilla?.();
            else isVanilla?.();
            this.setState({ vanilla: vanilla });
        }
    }


    importCSS(href) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        link.dataset.dynamic = "true"; // Tag for later removal
        document.head.appendChild(link);
    }

    undefineCSS(href) {
        const links = document.querySelectorAll(`link[rel="stylesheet"][href="${href}"]`);
        links.forEach(link => link.remove());
    }

    async getSettings() {
        try {
            let j = await qreq.getAsync('/api/settings/info');
            if (j.item)
                this.setState({ SETTINGS: j.item });
        }
        catch { }
    }


}

